import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { Image } from 'office-ui-fabric-react/lib/Image';
import { resolve as urlResolve } from 'url';
import { getPackageBaseUrl } from 'owa-config';
import { PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import loc from 'owa-localize';
import closeGetStartedInListView from '../actions/closeGetStartedInListView';
import { logUsage } from 'owa-analytics';

import {
    getStarted_ListView_CloseButton_Text,
    getStarted_ListView_Complete_Text,
} from '../getStarted.locstring.json';

const completedImage = require('./img/completed.svg');
const styles = require('./CompletionScreen.scss');

const CompletionScreen = observer(function CompletionScreen(props: {}) {
    return (
        <div className={styles.completionScreenWrapper}>
            <Image
                title={loc(getStarted_ListView_Complete_Text)}
                className={styles.completionScreenImage}
                shouldFadeIn={false}
                src={urlResolve(getPackageBaseUrl(), completedImage)}
            />
            <div className={styles.completionScreenText}>
                {loc(getStarted_ListView_Complete_Text)}
            </div>
            <div className={styles.completionScreenButton}>
                <PrimaryButton
                    onClick={onCloseButtonClicked}
                    text={loc(getStarted_ListView_CloseButton_Text)}
                />
            </div>
        </div>
    );
});

export default CompletionScreen;

function onCloseButtonClicked(): void {
    logUsage('CloseButtonInCompletionScreenClicked', [], { isCore: true });
    closeGetStartedInListView();
}
